export default __webpack_public_path__ + "static/media/service.ce890126.svg";